import { projectClient } from '../../client/client';

export const version = {
  get: projectClient('/version').get,
};
